module.exports = __webpack_public_path__ + "static/media/logo-full-148.f1ac6a67.png";